import { Home } from "pages/Home";
import { SignIn } from "pages/SignIn";
import { PrivatePage } from "pages/privatePage"
import { DriverPrivatePage } from "pages/driverPrivatePage"
import { DriverHome } from "pages/Driver/Home";
import { DriverPunctuality } from "pages/Driver/Punctuality";
import { DriverComplaints } from "pages/Driver/Complaints";
import { DriverDeliveries } from "pages/Driver/Deliveries";
import { DriverBoxes } from "pages/Driver/Boxes";
import { useRoutes } from "react-router-dom";
import { Deliveries } from "pages/Deliveries";
import { DeliveryStatus } from "pages/DeliveryStatus";
import { Drivers } from "pages/Drivers/DriverPage";
import { ClientPage } from "pages/ClientPage";
import { BoxReturn } from "pages/BoxReturn";
import { Teams } from "pages/Drivers/TeamPage";
import { RoutePage } from "pages/RoutePage";
import { Priority } from "pages/PriorityPages";
import { BoxCount } from "pages/BoxCount";
import { ExportRoutes } from "pages/ExportRoutes";
import { SupportDrivers } from "pages/SupportDriver";
import { Dashboard } from "pages/Dashboard";
import { Punctuality } from "pages/Punctuality";
import { Complaints } from "pages/Complaints";
import DefaultCosts from "pages/CostManagement/DefaultCosts";
import { FirstMile } from "pages/CostManagement/FirstMile";
import { LastMile } from "pages/CostManagement/LastMile";
import { Support } from "pages/CostManagement/Support";
import { RouteOptimization } from "pages/RouteOptimization";
import { PhysicalTransshipPage } from "pages/PhysicalTransship";
import { Navigate } from "react-router-dom";
const Routes = () => {
  return useRoutes([
    {
      path: '/',
      element: <SignIn/>
    },
    {
      path: '/home',
      element: <PrivatePage children={<Home />}/>,
    },
    {
      path: '/deliveries',
      element: <PrivatePage children={<Deliveries />}/>
    },
    {
      path: '/box-return',
      element: <PrivatePage children={<BoxReturn />}/>
    },
    {
      path: '/export-routes',
      element: <PrivatePage children={<ExportRoutes />}/>
    },
    {
      path: '/box-count',
      element: <PrivatePage children={<BoxCount/>}/>
    },
    {
      path: '/delivery-status',
      element: <PrivatePage children={<DeliveryStatus />}/>
    },
    {
      path: '/drivers',
      element: <PrivatePage children={<Drivers />}/>
    },
    {
      path: '/support-drivers',
      element: <PrivatePage children={<SupportDrivers />}/>
    },
    {
      path: '/teams',
      element: <PrivatePage children={<Teams />}/>
    },
    {
      path: '/clients',
      element: <PrivatePage children={<ClientPage />}/>
    },
    {
      path: '/driver-punctuality',
      element: <PrivatePage children={<Punctuality />}/>
    },
    {
      path: '/driver-complaint',
      element: <PrivatePage children={<Complaints />}/>
    },
    {
      path: '/routes',
      element: <PrivatePage children={<RoutePage />}/>
    },
    {
      path: '/priority',
      element: <PrivatePage children={<Priority />}/>
    },
    {
      path: '/dashboard',
      element: <PrivatePage children={<Dashboard />}/>
    },
    {
      path: '/cost-management/default-costs',
      element: <PrivatePage children={<DefaultCosts />}/>
    },
    {
      path: '/cost-management/first-mile',
      element: <PrivatePage children={<FirstMile />}/>
    },
    {
      path: '/cost-management/last-mile',
      element: <PrivatePage children={<LastMile />}/>
    },
    {
      path: '/cost-management/support',
      element: <PrivatePage children={<Support />}/>
    },
    {
      path: '/route-optimization',
      element: <PrivatePage children={<RouteOptimization />}/>
    },
    {
      path: '/transshipments',
      element: <PrivatePage children={<PhysicalTransshipPage />}/>
    },
    {
      path: '/motorista',
      element: <DriverPrivatePage children={<DriverHome />}/>
    },
    {
      path: '/motorista/pontualidade',
      element: <DriverPrivatePage children={<DriverPunctuality />}/>
    },
    {
      path: '/motorista/quebras',
      element: <DriverPrivatePage children={<DriverComplaints />}/>
    },
    {
      path: '/motorista/entregas',
      element: <DriverPrivatePage children={<DriverDeliveries />}/>
    },
    {
      path: '/motorista/caixas',
      element: <DriverPrivatePage children={<DriverBoxes />}/>
    },
    {
      path: '*',
      element: <PrivatePage children={<Home />}/>
    }

  ])
}

export default Routes;
